module.exports = __webpack_public_path__ + "assets/img/title-d73b5304.png";